// src/lib/firebase.js
import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyB78EhApHflHOUBkA0LQrCAYRYbPsPNm_Q",
  authDomain: "evonpolishing-c18da.firebaseapp.com",
  projectId: "evonpolishing-c18da",
  storageBucket: "evonpolishing-c18da.firebasestorage.app",
  messagingSenderId: "36696569711",
  appId: "1:36696569711:web:8e8c816a56785927699a9a",
  measurementId: "G-J64EPCECRM",
};

const app = initializeApp(firebaseConfig);

// ✅ analytics is optional; initialize safely
export let analytics = null;

if (typeof window !== "undefined") {
  isSupported()
    .then((ok) => {
      if (ok) analytics = getAnalytics(app);
    })
    .catch(() => {
      // leave analytics as null
    });
}

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;
